import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "mswdc_admin_auth";

export function getAdminAuthHeader() {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(STORAGE_KEY);
}

export function setAdminAuthHeader(header) {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, header);
}

export function clearAdminAuth() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
}

function authedAxios() {
  const auth = getAdminAuthHeader();
  const inst = axios.create({
    baseURL: API,
    headers: {
      "Content-Type": "application/json",
      ...(auth ? { Authorization: auth } : {}),
    },
  });
  return inst;
}

export async function adminLogin(username, password) {
  // Build Basic auth header and verify with /admin/whoami
  const token = btoa(`${username}:${password}`);
  const header = `Basic ${token}`;
  const r = await axios.get(`${API}/admin/whoami`, {
    headers: { Authorization: header },
  });
  setAdminAuthHeader(header);
  return r.data;
}

export async function listDrafts() {
  const { data } = await authedAxios().get("/newsletter/drafts");
  return data;
}

export async function createDraft({ topic, notes }) {
  const { data } = await authedAxios().post("/newsletter/drafts", { topic, notes });
  return data;
}

export async function updateDraft(id, { subject, body_text }) {
  const { data } = await authedAxios().put(`/newsletter/drafts/${id}`, { subject, body_text });
  return data;
}

export async function deleteDraft(id) {
  const { data } = await authedAxios().delete(`/newsletter/drafts/${id}`);
  return data;
}

export async function sendDraft(id) {
  const { data } = await authedAxios().post(`/newsletter/drafts/${id}/send`);
  return data;
}

export async function listSubscribers() {
  const { data } = await authedAxios().get("/newsletter/subscribers");
  return data;
}
